module.exports = __webpack_public_path__ + "static/media/card1.18a86bbe.png";